export const TilesList = [
    {
        'name': 'deviceMgmt.security'
    },
    {
        'name': 'deviceMgmt.core'
    },
    {
        'name': 'deviceMgmt.firmwareMgmt'
    },
    {
        'name': 'deviceMgmt.localAuth'
    },
    {
        'name': 'deviceMgmt.reservation'
    },
    {
        'name': 'deviceMgmt.remoteTrigger'
    },
    {
        'name': 'deviceMgmt.smartCharging'
    }
]


export const TilesDetailsList = [
    {
        'name': 'deviceMgmt.changeAvailability',
        'description': 'Update a Charge Point Availability.',
        'target': '#changeAvailability'
    },
    {
        'name': 'deviceMgmt.changeConfiguration',
        'description': 'Change a Charge Point Configuration.',
        'target': '#changeConfiguration'
    },
    {
        'name': 'deviceMgmt.clearCache',
        'description': 'Clear Authorization Cache of a Charge Point.',
        'target': '#clearCache'
    },
    {
        'name': 'deviceMgmt.dataTransfer',
        'description': 'Functions not supported by OCPP specification.',
        'target': '#dataTransfer'
    },
    {
        'name': 'deviceMgmt.getConfiguration',
        'description': 'Fetch a Charge Point Configuration.',
        'target': '#getConfiguration'
    },
    {
        'name': 'deviceMgmt.remoteStartTransaction',
        'description': 'Remote Start Transaction on a Charge Point.',
        'target': '#remoteStartTransaction'
    },
    {
        'name': 'deviceMgmt.remoteStopTransaction',
        'description': 'Remote Stop Transaction on a Charge Point.',
        'target': '#remoteStopTransaction'
    },
    {
        'name': 'deviceMgmt.unlockConnector',
        'description': 'Unlock a Charge Point Connector.',
        'target': '#unlockConnector'
    },
    {
        'name': 'deviceMgmt.reset',
        'description': 'Reset a Charge Point.',
        'target': '#reset'
    }
];


export const FirmwareList = [
    {
        'name': 'deviceMgmt.updateFirmware',
        'description': 'Update Firmware on a Charge Point.',
        'target': '#updateFirmware'
    },
    {
        'name': 'deviceMgmt.getDiagnostics',
        'description': 'Get Diagnostic Information of a Charge Point.',
        'target': '#getDiagnostics'
    }
];

export const LocalList = [
    {
        'name': 'deviceMgmt.localVersion',
        'description': 'Fetch Local Authorization List version of a charge point.',
        'target': '#getLocalListVersion'
    },
    {
        'name': 'deviceMgmt.sendLocalList',
        'description': 'Update Local Authorization List of a charge point.',
        'target': '#sendLocalList'
    }
];

export const ReservationList = [
    {
        'name': 'deviceMgmt.reserveNow',
        'description': 'Reserve a Charge Point connector for use by a specific idTag.',
        'target': '#reserveNow'
    },
    {
        'name': 'deviceMgmt.cancelReservation',
        'description': 'Cancel an existing Reservation.',
        'target': '#cancelReservation'
    }
];

export const TriggerList = [
    {
        'name': 'deviceMgmt.triggerMessage',
        'description': 'Remote Trigger Charge Point initiated messages.',
        'target': '#triggerMessage'
    }
];

export const ChargingList = [
    {
        'name': 'deviceMgmt.setChargingProfile',
        'description': 'Set a Charging Profile on a Charge Point Connector.',
        'target': '#setChargingProfile'
    },
    {
        'name': 'deviceMgmt.clearChargingProfile',
        'description': 'Clear a Charging Profile on a Charge Point Connector.',
        'target': '#clearChargingProfile'
    },
    {
        'name': 'deviceMgmt.getCompositeSchedule',
        'description': 'Get Composite Charging Schedule on a Charge Point Connector.',
        'target': '#getCompositeSchedule'
    }
];